import "./ResidentialScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import Residential from "./sections/Residential";
import Expectations from "./sections/Expectations";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function ResidentialScaffoldingPage() {
  return <div>
      <Header />
      <Residential />
      <Expectations />
      <Quote />
      <Footer />
    </div>;
}